import { authFetch } from "lib/api/authFetch";
import { BACKEND_URL } from "lib/utils/baseUrl";
import { normalizeApiMessage } from "lib/i18n/apiMessage";

function normalizeApiMessageWithFallbackKey(
  payload,
  fallbackMessage,
  fallbackKey,
) {
  const normalized = normalizeApiMessage(payload, fallbackMessage);
  return {
    ...normalized,
    messageKey: normalized.messageKey || fallbackKey || "",
  };
}

export async function postMarkAsDeleted(projectId, ids) {
  if (!projectId || !Array.isArray(ids) || ids.length < 1) {
    return {
      success: false,
      ...normalizeApiMessageWithFallbackKey(
        { message: "Invalid file delete request." },
        "Invalid file delete request.",
        "api.project.file.delete.validation.invalidRequest",
      ),
    };
  }

  try {
    const path = `${BACKEND_URL}/project/${projectId}/file/mark-deleted`;

    const response = await authFetch(
      path,
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ ids }),
      },
      {
        refreshUrlIncludes: "auth/refresh",
      },
    );

    if (response.status === 401) {
      return {
        success: false,
        ...normalizeApiMessageWithFallbackKey(
          { message: "Session expired. Please sign in again." },
          "Session expired. Please sign in again.",
          "api.auth.token.expired",
        ),
      };
    }

    const result = await response.json().catch(() => null);
    if (!result) {
      return {
        success: false,
        ...normalizeApiMessageWithFallbackKey(
          { message: "Failed to parse server response." },
          "Failed to parse server response.",
          "api.common.serverError",
        ),
      };
    }

    if (!response.ok || result?.success !== true) {
      const fallbackKey =
        response.status === 404
          ? "api.project.file.delete.notFound"
          : response.status === 400
            ? "api.project.file.delete.validation.invalidRequest"
            : "api.project.file.delete.failed";

      return {
        success: false,
        ...normalizeApiMessageWithFallbackKey(
          result,
          "Request failed.",
          fallbackKey,
        ),
      };
    }

    return {
      success: true,
      ...normalizeApiMessageWithFallbackKey(
        result,
        "Files marked as deleted.",
        "api.project.file.delete.success",
      ),
    };
  } catch (error) {
    console.error(error);
    return {
      success: false,
      ...normalizeApiMessageWithFallbackKey(
        { message: "Server request failed." },
        "Server request failed.",
        "api.common.networkError",
      ),
    };
  }
}
